import { IitemPedido } from "../../../interfaces/itemPedido";
import styles from "./CardItemPedido.module.scss";

export default function CardItemPedido({ itens }: { itens: IitemPedido[] }) {
    return (
        <table className={styles.cardTable}>
            <thead>
                <tr>
                    <th>Descrição do Produto</th>
                    <th>UND.</th>
                    <th>QTDE.</th>
                    <th>UNIT (R$)</th>
                    <th>SUB-TOTAL</th>
                </tr>
            </thead>
            <tbody>
                {itens.map((item, index) => (
                    <tr key={index}>
                        <td>{item.descricao}</td>
                        <td>{item.unidade}</td>
                        <td>{item.quantidade}</td>
                        <td>{item.valorUnidade}</td>
                        <td>{item.valorTotal}</td>
                    </tr>
                ))}
            </tbody>
        </table>
    );
}

